<template>
    <v-container class="max-container">
        <v-row>
            <v-col class="no-pd-l">
                <span class="row_col__spantitle">{{'Notificações'}}</span>
            </v-col>
        </v-row>
        <v-row v-if="hasNotifications">           
            <v-col 
                v-for="(notification, index) in notifications" :key="index"
                class="no-pd-l"
                cols="12" sm="12" md="12" lg="12" xl="12"
            >
                <v-card class="notification__card" elevation="4">
                    <v-container class="notification__container" :class="mobileVersion ? '' : 'container_no-mobile'">
                        <div>
                            <v-card-title>
                                <span class="vcard_cardtitle__title">{{notification.title}}</span>
                            </v-card-title>
                            <v-card-subtitle>
                                <v-icon color="var(--cor--preta)">mdi-calendar-blank</v-icon>
                                <span class="vcard_cardsubtitle__subtitle">{{notification.rescueDate}} - {{notification.rescueHour}}</span>
                            </v-card-subtitle>
                        </div>
                        <v-card-text>
                            <span class="vcard_cardtext__description">{{notification.description}}</span>
                        </v-card-text>
                    </v-container>
                </v-card>
            </v-col>            
        </v-row>
        <v-row v-if="!hasNotifications" class="flex-col-center">
            <h3 class="text-center"> Ainda não temos comunicados por aqui... </h3>

            <v-img :max-width="dynamicWidthImg" class="empty--img" src="@/assets/emptyView-notifications.svg" />
        </v-row>
    </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Services
import { getNotificationsByCurrentContactIdAndCompanyId } from "./service/notification.service";

export default {
    name: 'Notifications',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        notifications: [],
        hasNotifications: false,
        dynamicWidthImg: '60%',
        //controle
        mobileVersion: false
    }),
    created() {
        this.compareWidth()
        this.getScreenInfo()
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        ...mapActions('notificationsLoaderStore', ['SET_NOTIFICATIONS_STATE']),
        compareWidth() {
            ( window.innerWidth < 640)? this.dynamicWidthImg = '80%' : this.dynamicWidthImg = '60%';
            if( window.innerWidth <= 700 ) {
                this.mobileVersion = true
              
            } else this.mobileVersion = false
        },
        getScreenInfo() {
            getNotificationsByCurrentContactIdAndCompanyId(this.currentCompany.id)
                .then( success => {
                    if( success.data.length < 1 ){
                        this.hasNotifications = false
                    
                    } else {
                            this.hasNotifications = true
                            success.data.forEach( element => {
                                    var moment = require('moment')
                                    this.notifications.push( {
                                            title: element.title,
                                            rescueDate: moment(element.date).format("YYYY-MM-DD"),
                                            rescueHour: moment(element.date).format("HH:mm"),
                                            description: element.description != null ? element.description : ''
                                        }
                                    )
                                }
                            )
                        }
                    this.SET_NOTIFICATIONS_STATE(true)
                    }
                )
                .catch( error => {
                        this.hasNotifications = false
                        this.SET_NOTIFICATIONS_STATE(true)

                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        }
    }
}
</script>

<style scoped>
.row_col__spantitle {
    font-weight: 800;
    font-size: 22px;
    color: var(--cor--preta)
}
.container_no-mobile{
    display: flex;
    flex-direction: row;
    align-items: baseline;

}
.vcard_cardtitle__title {
    font-weight: bold;
    font-size: 20px;
    color: var(--cor--preta);
    width: 200px !important;
}
.vcard_cardsubtitle__subtitle {
    padding-left: 6px;
    font-weight: 400;
    font-size: 14px;
    color: var(--cor--preta)
}
.vcard_cardtext__description {
    font-weight: 400;
    font-size: 14px;
    color: var(--cor--preta)
}
.notification__container {
    padding: 0px;
    overflow: auto;
    width: 100%;
    max-height: 150px;
    min-height: 150px;    
}
.notification__card {
    overflow-y: auto !important;
}
</style>